import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import JoditEditor from "jodit-react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import EditableTable from "../shared/EditableTable";
const baseURL = process.env.REACT_APP_API_JOBS;
const Protocol = ({ onLeave, onChangedStatus, ...props }) => {
  //function Protocol(props) {
  const { visible, mekhraz, bhinaMeeting, setBhinaMeeting, department } = props;
  const [bhinaMembers, setBhinaMembers] = useState(null);
  const [bhinaMembersSelector, setBhinaMembersSelector] = useState(null);
  const [moamadeem, setMoamadeem] = useState(null);
  const [invitedMoamadeem, setInvitedMoamadeem] = useState([]);
  const [invitedMoamadeemSelector, setInvitedMoamadeemSelector] =
    useState(null);
  const [bhinaNotes, setBhinaNotes] = useState(null);
  const [moamadeemInterView, setMoamadeemInterView] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  const [displayChoices, setDisplayChoices] = useState(null);
  const [kshereem, setKshereem] = useState(["", "", ""]);
  const [markAttendMoamad, setMarkAttendMoamad] = useState([]);
  const [moamadWord, setMoamadWord] = useState(null);
  const [disclaimers, setDisclaimers] = useState(null);
  const [assessment, setAssessment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [changed, setChanged] = useState(false);
  const isSubmitting = useRef(false); // Use ref instead of state
  const editor1 = useRef(null);
  const editorsMoamad = useRef([]);
  const editorsDisclaimer = useRef([]);
  const config = useMemo(
    () => ({
      readonly: false,
      height: 400,
      width: 600,
      askBeforePasteFromWord: false,
      askBeforePasteHTML: false,
      //colorPickerDefaultTab: "background",
      toolbarAdaptive: false,
      disablePlugins: ["File", "Image", "Media"],
    }),
    [],
  );
  let saveSuccess = true;
  const navigate = useNavigate();
  const location = useLocation();
  const isMountedGlobal = useRef(true);

  useEffect(() => {
    return () => {
      isMountedGlobal.current = false;
    };
  }, []);
  useEffect(() => {
    onChangedStatus(changed);
  }, [changed]);

  // blocks browser refresh/close
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (changed) {
        e.preventDefault();
        e.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [changed]);

  // blocks browser back button
  useEffect(() => {
    if (changed) {
      window.history.pushState(null, "", window.location.href);
      const handlePopState = () => {
        const confirm = window.confirm(
          "השינויים לא נשמרו. האם אתה בטוח שברצונך לעזוב?",
        );
        if (confirm) {
          window.history.back();
        } else {
          window.history.pushState(null, "", window.location.href);
        }
      };
      window.addEventListener("popstate", handlePopState);
      return () => window.removeEventListener("popstate", handlePopState);
    }
  }, [changed]);

  useEffect(() => {
    setDisplayChoices(bhinaMeeting.lo_nevhar_moamad);
    let isMounted = true;
    const controller = new AbortController();
    const getBhinaMembers = async () => {
      if (typeof bhinaMeeting.id != "undefined") {
        try {
          const response = await axiosPrivate.get(
            baseURL + "bhinamember2?meeting_id=" + bhinaMeeting.id,
            {
              signal: controller.signal,
            },
          );
          if (isMounted) {
            setBhinaMembers(response.data);
            setBhinaMembersSelector(
              response.data.map(({ id, member_name }) => ({
                id,
                name: `${member_name}`,
              })),
            );
          }
        } catch (err) {
          if (err.response) {
            alert(HandleHttpErrors(err.response.status));
            if (err.response.status === 401) {
              navigate("/login", { state: { from: location }, replace: true });
            } else if (err.response.status === 403) {
              alert(HandleHttpErrors(err.response.status));
            }
            console.log(err.response);
          } else if (err.request) {
            alert(
              " The client never received a response, and the request was never left",
            );
            console.log(err.request);
          } else {
            console.log(err);
            alert(" Anything else(1)");
          }
        }
      }
    };
    const getAssessment = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "assessment?mekhraz_id=" + mekhraz.id,
          {
            signal: controller.signal,
          },
        );
        if (isMounted) {
          setAssessment(response.data[0]);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else(2)");
        }
      }
    };

    const fetchData = async () => {
      let responseM = null;
      let responseI = null;
      try {
        responseM = await axiosPrivate.get(
          baseURL + "moamad?mekhraz_id=" + mekhraz.id,
          {
            signal: controller.signal,
          },
        );
        isMounted && setMoamadeem(responseM.data);
      } catch (err) {
        if (err.responseM) {
          alert(HandleHttpErrors(err.responseM.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.responseM.status));
          }
          console.log(err.responseM);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else(3)");
        }
      }

      try {
        responseI = await axiosPrivate.get(
          baseURL + "moamadinterview?bhina_id=" + bhinaMeeting.id,
          {
            signal: controller.signal,
          },
        );
        isMounted && setMoamadeemInterView(responseI.data);
      } catch (err) {
        if (err.responseI) {
          alert(HandleHttpErrors(err.responseI.status));
          if (err.responseI.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.responseI.status));
          }
          console.log(err.responseI);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else(4)");
        }
      }

      const newArray = [];
      for (const invited of responseI.data) {
        // Find the object in array2 based on ID
        const matchingObject = responseM.data.find(
          (moamad) => moamad.id === invited.moamad,
        );
        // If a matching object is found, add it to the new array
        if (matchingObject) {
          const combinedObject = {
            //...invited,
            ...matchingObject,
            // Add other fields from responseI.data if needed
            attend: invited.attend,
            interviewId: invited.id,
            // Add other fields from matchingObject if needed
            // additionalField: matchingObject.additionalField,
          };

          newArray.push(combinedObject);
          setMarkAttendMoamad((prevState) => [
            ...prevState,
            {
              id: combinedObject.id,
              mark: combinedObject.mark,
              attend: combinedObject.attend,
              interview_id: combinedObject.interviewId,
            },
          ]);
        }
      }
      // Set the state variable M with the new array
      //setInvitedMoamadeem(newArray);
      setInvitedMoamadeem([
        ...new Map(newArray.map((m) => [m.id, m])).values(),
      ]);
      setInvitedMoamadeemSelector([
        ...new Map(
          newArray?.map(({ id, f_name, father_name, l_name }) => [
            id,
            { id, name: `${f_name} ${father_name} ${l_name}` },
          ]),
        ).values(),
      ]);
    };

    const fetchBhinaNotes = async () => {
      if (typeof bhinaMeeting.id != "undefined") {
        try {
          const response = await axiosPrivate.get(
            baseURL + "bhinameetingnotes?meeting_id=" + bhinaMeeting.id,
            {
              signal: controller.signal,
            },
          );
          if (isMounted) {
            setBhinaNotes(response.data);
            setLoading(false);
          }
        } catch (err) {
          if (err.response) {
            alert(HandleHttpErrors(err.response.status));
            if (err.response.status === 401) {
              navigate("/login", { state: { from: location }, replace: true });
            } else if (err.response.status === 403) {
              alert(HandleHttpErrors(err.response.status));
            }
            console.log(err.response);
          } else if (err.request) {
            alert(
              " The client never received a response, and the request was never left",
            );
            console.log(err.request);
          } else {
            console.log(err);
            alert(" Anything else(5)");
          }
        }
      }
    };
    getAssessment();
    getBhinaMembers();
    fetchData();
    fetchBhinaNotes();
  }, []);

  useEffect(() => {
    setMoamadWord(
      bhinaNotes?.filter((item) => item.note_type.includes("דברי המועמד")),
    );
    setDisclaimers(
      bhinaNotes?.filter((item) => item.note_type.includes("הסתייגות")),
    );
  }, [bhinaNotes]);

  useEffect(() => {
    const findNameById = (id) => {
      const foundItem = invitedMoamadeemSelector?.find(
        (item) => item.id === id,
      );
      return foundItem ? foundItem.name : "";
    };
    const updatedKshereem = [...kshereem]; // Create a copy of the array
    updatedKshereem[0] = findNameById(bhinaMeeting.kasheer_a);
    updatedKshereem[1] = findNameById(bhinaMeeting.kasheer_b);
    updatedKshereem[2] = findNameById(bhinaMeeting.kasheer_c);
    setKshereem(updatedKshereem);
  }, [invitedMoamadeemSelector]);

  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;
    setChanged(true);
    setDisplayChoices(!checked);
    setBhinaMeeting((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const changeMemberAttend = (id, e) => {
    const { name, checked } = e.target;
    setChanged(true);
    setBhinaMembers((prevState) => {
      // Find the index of the item with the given id
      const index = prevState.findIndex((item) => item.id === id);
      // If the item is found, update it
      if (index !== -1) {
        // Create a copy of the array
        const newArray = [...prevState];
        // Update the specific item with the given id
        newArray[index] = {
          ...newArray[index],
          [name]: checked,
        };

        // Return the updated array
        return newArray;
      }
      // If the item is not found, return the original array
      return prevState;
    });
  };

  const changeMarkAttend = (id, e) => {
    const { name, value, checked } = e.target;
    setChanged(true);
    setMarkAttendMoamad((prevState) => {
      // Find the index of the item with the given id
      const index = prevState.findIndex((item) => item.id === id);

      // If the item is found, update it
      if (index !== -1) {
        // Create a copy of the array
        const newArray = [...prevState];

        // Update the specific item with the given id
        if (name == "mark") {
          newArray[index] = {
            ...newArray[index],
            [name]: value,
          };
        } else {
          newArray[index] = {
            ...newArray[index],
            [name]: checked,
          };
        }

        // Return the updated array
        return newArray;
      }

      // If the item is not found, return the original array
      return prevState;
    });
  };

  const changeBhina = (e) => {
    e.preventDefault();
    setChanged(true);
    const { name, value, checked, type } = e.target;
    if (type === "checkbox") {
      const checkedValue = checked ? 1 : 0;
      setDisplayChoices(!checked);
      setBhinaMeeting((prevState) => ({
        ...prevState,
        [name]: checkedValue,
      }));
    } else {
      setBhinaMeeting((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const changeBhinaDDS = (e) => {
    e.preventDefault();
    setChanged(true);
    const { name, value } = e.target;
    const selectedName = e.target.options[e.target.selectedIndex].text;
    const updatedKshereem = [...kshereem]; // Create a copy of the array
    if (e.target.name == "kasheer_a") {
      updatedKshereem[0] = selectedName;
    }
    if (e.target.name == "kasheer_b") {
      updatedKshereem[1] = selectedName;
    }
    if (e.target.name == "kasheer_c") {
      updatedKshereem[2] = selectedName;
    }
    setKshereem(updatedKshereem);
    setBhinaMeeting((prevState) => {
      const updatedState = {
        ...prevState,
        [name]: Number(value) == 0 ? null : Number(value),
      };
      return updatedState;
    });
  };

  const downloadAsWord = () => {
    let divContent1 = document.getElementById("div2word1").innerHTML;
    let divContent2 = document.getElementById("div2word2").innerHTML;
    // Remove the button from the cloned content
    //const endString = `<textarea name="decision_reason" style="display: none;"></textarea>`;
    //const startString = '<div class="ace_layer ace_marker-layer">';
    //const regex = new RegExp(`${startString}[\\s\\S]*?${endString}`, "g");
    //divContent1 = divContent1.replace(regex, "");
    const deletetButton = new RegExp(`הסרה</button>`, "g");
    divContent1 = divContent1.replace(
      /<select\b[^>]*>[\s\S]*?<\/select>/gi,
      "",
    );
    divContent2 = divContent2.replace(
      /<select\b[^>]*>[\s\S]*?<\/select>/gi,
      "",
    );
    const otherAttendsText = bhinaMeeting?.other_attends || "";
    const formattedOtherAttends = otherAttendsText.replace(/\n/g, "<br />");
    const textareaRegex =
      /<textarea[^>]*id="other_attends"[^>]*>([\s\S]*?)<\/textarea>/;

    // Update div2word1 content by replacing <textarea> with formatted <div>
    divContent1 = divContent1.replace(
      textareaRegex,
      `<div
          id="other_attends"
          style="white-space: pre-wrap; width: 600px; height: 150px; border: 1px solid #ccc; padding: 5px; text-align: right;"
        >${formattedOtherAttends}</div>`,
    );
    divContent1 = divContent1.replace(deletetButton, "");
    divContent1 = divContent1.replace("הוסף דברי מועמד", "");
    divContent1 = divContent1.replace("הוסף הערה/הסתייגות", "");
    if (!bhinaMeeting.lo_nevhar_moamad) {
      divContent2 = divContent2.replace("הוועדה החליטה לא לבחור באף מועמד", "");
    }
    if (bhinaMeeting.kasheer_a == null) {
      divContent2 = divContent2.replace("הוועדה החליטה לבחור :", "");
    }
    if (bhinaMeeting.kasheer_b == null) {
      divContent2 = divContent2.replace("כשיר ב' : ", "");
    }
    if (bhinaMeeting.kasheer_c == null) {
      divContent2 = divContent2.replace("כשיר ג' : ", "");
    }
    let allContent = divContent1 + divContent2;
    // Create a basic HTML template with the content
    const htmlTemplate = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="UTF-8">
          <title>Document</title>
        </head>
        <body>
          ${divContent1}
          ${moamadWord && moamadWord.length > 0
        ? `
          <div dir="RTL">
            <p dir="RTL">
              <strong>עיקרי דבריהם של המועמדים:</strong>
            </p>
            ${moamadWord
          ?.map(
            (item, index) =>
              `<strong><i>${item.person_name}</i></strong><div style="border: thin solid black">${item.note}</div><br/>`,
          )
          .join("")}
          </div>
        `
        : ""
      }

        ${disclaimers && disclaimers.length > 0
        ? `
        <div dir="RTL">
          <p dir="RTL">
          <strong>הערות/הסתייגויות:</strong>
          </p>
          ${disclaimers
          ?.map(
            (item, index) =>
              `<strong><i>${item.person_name != "" ? item.person_name : "הערה:"
              }</i></strong><div style="border: thin solid black">${item.note
              }</div><br/>`,
          )
          .join("")}
        </div>
      `
        : ""
      }

          <div dir="RTL">
          <p dir="RTL">
          <u>
            <strong>נימוקים להחלטות:</strong>
          </u>
        </p>
          ${bhinaMeeting.decision_reason ? bhinaMeeting.decision_reason : ""}
          </div>
          ${divContent2}
        </body>
      </html>
    `;
    // Create a Blob with the HTML content
    const blob = new Blob([htmlTemplate], { type: "application/msword" });
    // Create a data URI and trigger the download
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "document.doc";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const saveUpdates = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault(); // Prevent form from submitting when called by submit event
    }
    let isMounted = true;
    setChanged(false);
    const controller = new AbortController();
    const saveBhinaMeeting = async () => {
      try {
        console.log("saveBhinaMeeting");
        const response = await axiosPrivate.put(
          baseURL + "bhinameeting/" + bhinaMeeting.id + "/",
          bhinaMeeting,
          {
            signal: controller.signal,
          },
        );
        if (isMounted) {
          saveSuccess = false;
        }
      } catch (err) {
        saveSuccess = false;
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else(6)");
        }
      }
    };

    const allNotes = {
      moamadsWord: { ...moamadWord },
      disclaimers: { ...disclaimers },
      bhina_meeting_id: bhinaMeeting.id,
      invited_moamadeem: { ...invitedMoamadeem },
    };
    const saveBhinaMeetingNotes = async () => {
      try {
        console.log("saveBhinaMeetingNotes");
        const response = await axiosPrivate.post(
          baseURL + "bhinameetingnotes/",
          allNotes,
          {
            signal: controller.signal,
          },
        );
        if (isMounted) {
          setBhinaNotes(response.data);
          setChanged(false);
          saveSuccess = false;
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else(7)");
        }
      }
    };
    const saveMarkAttend = async () => {
      try {
        console.log("saveMarkAttend");
        const response = await axiosPrivate.put(
          baseURL + "moamadmark/" + "0" + "/",
          markAttendMoamad,
          {
            signal: controller.signal,
          },
        );
        if (isMounted) {
          saveSuccess = false;
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else(8)");
        }
      }
    };

    const saveMemberAttend = async () => {
      try {
        //the id=0 means that the data is an array of items
        console.log("saveMemberAttend");
        const response = await axiosPrivate.put(
          baseURL + "bhinamember2/" + "0" + "/",
          bhinaMembers,
          {
            signal: controller.signal,
          },
        );
        if (isMounted) {
          saveSuccess = false;
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else(9)");
        }
      }
    };

    saveBhinaMeeting();
    saveBhinaMeetingNotes();
    if (markAttendMoamad.length > 0) {
      saveMarkAttend();
    }
    saveMemberAttend();
    if (isMounted && saveSuccess) {
      alert("העדכון עבר בהצלחה");
      saveSuccess = true;
    }
  };

  /*useEffect(() => {
    return () => {
      console.log("11111111111111111");
      if (changed && !isSubmitting.current) {
        console.log("222222222222222222");
        const confirmLeave = window.confirm(
          "ערכת שינויים, האם ברצונך לשמור אותם?"
        );
        if (confirmLeave) {
          console.log("Saving changes...");
          alert("wait");
          saveUpdates()
            .then(() => {
              // Optionally, handle success or cleanup
            })
            .catch((error) => {
              console.error("Error saving changes: ", error);
            });
        }
      }
    };
  }, [changed]);*/
  if (!visible || bhinaMeeting == null) return;
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    return (
      <div
        style={{
          marginRight: "50px",
          color: "black",
          backgroundColor: "#cbebff",
        }}
      >
        <div
          style={{
            marginRight: "20px",
          }}
        >
          <button
            onClick={downloadAsWord}
            className="btn btn-primary"
            disabled={changed}
          >
            הורדה לקובץ Word
          </button>
          {"  "}
          <button
            onClick={(e) => {
              isSubmitting.current = true;
              saveUpdates(e);
            }}
            className="btn btn-danger"
            disabled={!changed}
          >
            שמור הפרוטוקול
          </button>
        </div>
        <div
          id="div2word1"
          style={{
            marginRight: "20px",
          }}
        >
          <div style={{ width: "600px" }}>
            <p align="center" dir="RTL">
              <strong>פרוטוקול ועדת בחינה מספר: {bhinaMeeting.mt_num}</strong>{" "}
              <strong></strong>
            </p>
            <p align="center" dir="RTL">
              למכרז מס': {mekhraz.mkh_num}
            </p>
          </div>
          <p dir="RTL">
            <strong>
              <u>פרטי המשרה</u>
            </strong>
          </p>
          <div align="right" dir="rtl">
            <table dir="rtl" border="1" cellSpacing="0" cellPadding="0">
              <tbody>
                <tr>
                  <td width="166" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">תיאור המכרז</p>
                  </td>
                  <td width="94" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">סוג המכרז</p>
                  </td>
                  <td width="85" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">דרוג/דרגה</p>
                  </td>
                  <td width="95" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">תאריך הגשה</p>
                  </td>
                  <td width="113" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">תאריך הוועדה</p>
                  </td>
                </tr>
                <tr>
                  <td width="166" rowSpan="3" style={{ verticalAlign: "top" }}>
                    {mekhraz?.title}
                  </td>
                  <td width="94" style={{ verticalAlign: "top" }}>
                    {mekhraz.mkh_type}
                  </td>
                  <td width="85" style={{ verticalAlign: "top" }}>
                    {mekhraz.dirog}
                  </td>
                  <td width="95" style={{ verticalAlign: "top" }}>
                    {mekhraz.hagsha_date}
                  </td>
                  <td width="113" style={{ verticalAlign: "top" }}>
                    {bhinaMeeting.mt_date}
                  </td>
                </tr>
                <tr className="single-border-top">
                  <td width="94" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">מס' משרות</p>
                  </td>
                  <td width="85" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">אחוז משרה</p>
                  </td>
                  <td width="95" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">מחלקה</p>
                  </td>
                  <td width="113" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">ת. רישום פלילי</p>
                  </td>
                </tr>
                <tr className="border-top">
                  <td width="94" style={{ verticalAlign: "top" }}>
                    {mekhraz.mesrot_num}
                  </td>
                  <td width="85" style={{ verticalAlign: "top" }}>
                    {mekhraz.ahoz_mesra}
                  </td>
                  <td width="95" style={{ verticalAlign: "top" }}>
                    {department}
                  </td>
                  <td width="113" style={{ verticalAlign: "top" }}>
                    {mekhraz.reshom_plili ? "נדרש" : "לא נדרש"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p dir="RTL">
            <strong>
              <u>הרכב הוועדה </u>
              {bhinaMeeting?.length}
            </strong>
          </p>
          <div align="right" dir="rtl">
            <table dir="rtl" border="1" cellSpacing="0" cellPadding="0">
              <tbody>
                <tr>
                  <td width="138" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">שם</p>
                  </td>
                  <td width="138" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">תפקיד</p>
                  </td>
                  <td width="138" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">הופיע</p>
                  </td>
                  <td width="138" style={{ verticalAlign: "top" }}></td>
                </tr>
                {bhinaMembers?.map((member) => (
                  <tr key={member.id} className="border-top">
                    <td width="138" style={{ verticalAlign: "top" }}>
                      {member.member_name}
                    </td>
                    <td width="138" style={{ verticalAlign: "top" }}>
                      {member.member_role}
                    </td>
                    <td width="138" style={{ verticalAlign: "top" }}>
                      <p dir="RTL" className="exported-only">
                        {member.attend ? "כן" : "לא"}
                      </p>

                      <input
                        type="checkbox"
                        id="attend"
                        name="attend"
                        checked={member.attend}
                        onChange={(e) => changeMemberAttend(member.id, e)}
                      />
                    </td>
                    <td width="138" style={{ verticalAlign: "top" }}></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p dir="RTL">
            <strong>נוכחים נוספים (שם ותפקיד):</strong>
            <br />
            <textarea
              id="other_attends"
              name="other_attends"
              value={bhinaMeeting?.other_attends}
              onChange={changeBhina}
              style={{ resize: "none", width: "600px", height: "150px" }}
            />
          </p>
          <p dir="RTL">
            <strong>
              <u>המועמדים</u>
            </strong>
          </p>
          <p dir="RTL">
            {assessment
              ? "נערכה בחינה  " + assessment.assessment_type + "."
              : "לא נערכה בחינה."}
          </p>
          <p dir="RTL">
            מספר המועמדים שניגשו למכרז <strong>{moamadeem?.length}</strong>{" "}
            מתוכם נמצאו{" "}
            <strong>{moamadeem?.filter((item) => item.saf).length}</strong>{" "}
            שעמדו בתנאי הסף.
          </p>
          <p dir="RTL">
            <strong> המועמדים שהוזמנו לישיבה</strong>
          </p>
          <div align="right" dir="rtl">
            <table dir="rtl" border="1" cellSpacing="0" cellPadding="0">
              <tbody>
                <tr>
                  <td width="113" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">שם</p>
                  </td>
                  <td width="88" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">ת"ז</p>
                  </td>
                  <td width="74" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">אוכלוסיות*</p>
                  </td>
                  <td width="63" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">צרכים מיוחדים</p>
                  </td>
                  <td width="55" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">קירבה </p>
                  </td>
                  <td width="76" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">עמידה בתנאים</p>
                  </td>
                  <td width="37" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">ציון</p>
                  </td>
                  <td width="47" style={{ verticalAlign: "top" }}>
                    <p dir="RTL">הופיע</p>
                  </td>
                </tr>
                {invitedMoamadeem?.map((moamad, index) => (
                  <tr className="single-border-top">
                    <td width="113" style={{ verticalAlign: "top" }}>
                      <p dir="RTL">
                        {moamad.f_name +
                          " " +
                          (moamad.father_name ? moamad.father_name + " " : "") +
                          " " +
                          moamad.l_name}
                      </p>
                    </td>
                    <td width="88" style={{ verticalAlign: "top" }}>
                      <p dir="RTL">{moamad.idz}</p>
                    </td>
                    <td width="74" style={{ verticalAlign: "top" }}>
                      <p dir="RTL">
                        {moamad.arab_droze_circassian ? "(1)" : ""}
                        {moamad.ethiopian ? "(2)" : ""}
                      </p>
                    </td>
                    <td width="63" style={{ verticalAlign: "top" }}>
                      <p dir="RTL">{moamad.special_needs ? "כן" : "לא"}</p>
                    </td>
                    <td width="55" style={{ verticalAlign: "top" }}>
                      <p dir="RTL">
                        {moamad.relative_moamad?.length ? "קיימת" : "אין"}
                      </p>
                    </td>
                    <td width="76" style={{ verticalAlign: "top" }}>
                      <p dir="RTL">{moamad.saf ? "כן" : "לא"}</p>
                    </td>
                    <td width="100" style={{ verticalAlign: "top" }}>
                      <p dir="RTL" className="exported-only">
                        {
                          markAttendMoamad.filter(
                            (item) => item.id === moamad.id,
                          )[0].mark
                        }
                      </p>
                      <p dir="RTL">
                        <input
                          type="text"
                          name="mark"
                          value={
                            markAttendMoamad.filter(
                              (item) => item.id === moamad.id,
                            )[0].mark
                          }
                          onChange={(e) => changeMarkAttend(moamad.id, e)}
                          className="form-control"
                          id="mark"
                          placeholder=""
                        />
                      </p>
                    </td>
                    <td
                      width="60"
                      style={{
                        verticalAlign: "top",
                        alignContent: "center",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <p dir="RTL" className="exported-only">
                        {markAttendMoamad.filter(
                          (item) => item.id === moamad.id,
                        )[0].attend
                          ? "כן"
                          : "לא"}
                      </p>
                      <p dir="RTL">
                        <input
                          type="checkbox"
                          id="attend"
                          name="attend"
                          checked={
                            markAttendMoamad.filter(
                              (item) => item.id === moamad.id,
                            )[0].attend
                          }
                          onChange={(e) => changeMarkAttend(moamad.id, e)}
                        />
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p dir="RTL">
            *אוכלוסיות 1- נמנה על האוכלוסייה הערבית, הדרוזית או הצ'רקסית או 2-
            אתיופית
          </p>
        </div>
        <div
          style={{
            marginRight: "20px",
          }}
        >
          <p dir="RTL">
            <strong>עיקרי דבריהם של המועמדים:</strong>
          </p>

          <div>
            <EditableTable
              tableData={moamadWord}
              setTableData={setMoamadWord}
              bhina_meeting_id={bhinaMeeting.id}
              addRowName="הוסף דברי מועמד"
              deleteRowMame="הסרה"
              options={invitedMoamadeemSelector}
              optionType="המועמד "
              note_type="דברי המועמד"
              editors={editorsMoamad}
              setChanged={setChanged}
            />
          </div>
          <p dir="RTL">
            <u>
              <strong>הערות/הסתייגויות:</strong>
            </u>

            {
              <EditableTable
                tableData={disclaimers}
                setTableData={setDisclaimers}
                bhina_meeting_id={bhinaMeeting.id}
                addRowName="הוסף הערה/הסתייגות"
                deleteRowMame="הסרה"
                options={bhinaMembersSelector}
                optionType="חבר הוועדה  "
                note_type="הסתייגות"
                editors={editorsDisclaimer}
                setChanged={setChanged}
              />
            }
          </p>

          <p dir="RTL">
            <u>
              <strong>נימוקים להחלטות:</strong>
            </u>
          </p>
          <div dir="RTL">
            <JoditEditor
              editorRef={editor1}
              //tabIndex={2}
              name="decision_reason"
              value={bhinaMeeting?.decision_reason}
              config={config}
              onBlur={(newContent) => {
                setBhinaMeeting((prevState) => ({
                  ...prevState,
                  decision_reason: newContent,
                }));
              }}
              onChange={(newContent) => {
                if (bhinaMeeting?.decision_reason !== newContent) {
                  setChanged(true);
                }
              }}
            />
            <br />
          </div>
          <div
            id="div2word2"
            style={{
              marginRight: "20px",
            }}
          >
            <p dir="RTL" style={{ fontWeight: "bold", fontSize: "1.2em" }}>
              <u>החלטות:</u>
            </p>
            <p dir="RTL">
              <input
                type="checkbox"
                id="lo_nevhar_moamad"
                name="lo_nevhar_moamad"
                checked={bhinaMeeting.lo_nevhar_moamad}
                value={bhinaMeeting.lo_nevhar_moamad}
                onChange={handleCheckBoxChange}
              />{" "}
              הוועדה החליטה לא לבחור באף מועמד
            </p>
            {bhinaMeeting.lo_nevhar_moamad ? null : (
              <table dir="rtl">
                <tbody>
                  <tr dir="RTL" style={{ fontWeight: "bold" }}>
                    <td>הוועדה החליטה לבחור : </td>
                    <td>
                      <select
                        name="kasheer_a"
                        required
                        onChange={changeBhinaDDS}
                      >
                        <option value="0">לא נבחר מועמד</option>
                        {invitedMoamadeemSelector?.map((j) => (
                          <option
                            key={j.id}
                            value={j.id}
                            selected={j.id === bhinaMeeting.kasheer_a}
                          >
                            {j.name}
                          </option>
                        ))}
                      </select>{" "}
                      <span dir="RTL" className="exported-only">
                        {kshereem[0]}
                      </span>
                    </td>
                  </tr>
                  <tr dir="RTL" style={{ fontWeight: "bold" }}>
                    <td>כשיר ב' : </td>
                    <td>
                      <select
                        name="kasheer_b"
                        required
                        onChange={changeBhinaDDS}
                      >
                        <option value="0">לא נבחר מועמד</option>
                        {invitedMoamadeemSelector?.map((j) => (
                          <option
                            key={j.id}
                            value={j.id}
                            selected={j.id === bhinaMeeting.kasheer_b}
                          >
                            {j.name}
                          </option>
                        ))}
                      </select>{" "}
                      <span dir="RTL" className="exported-only">
                        {kshereem[1]}
                      </span>
                    </td>
                  </tr>
                  <tr dir="RTL" style={{ fontWeight: "bold" }}>
                    <td>כשיר ג' : </td>
                    <td>
                      <select
                        name="kasheer_c"
                        required
                        onChange={changeBhinaDDS}
                      >
                        <option value="0">לא נבחר מועמד</option>
                        {invitedMoamadeemSelector?.map((j) => (
                          <option
                            key={j.id}
                            value={j.id}
                            selected={j.id === bhinaMeeting.kasheer_c}
                          >
                            {j.name}
                          </option>
                        ))}
                      </select>{" "}
                      <span dir="RTL" className="exported-only">
                        {kshereem[2]}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
            <p id="p2word3" align="center" dir="RTL">
              <strong>חתימות</strong> <strong></strong>
            </p>
            <hr />
            <div align="right" dir="rtl">
              <table
                dir="rtl"
                border="1"
                cellSpacing="0"
                cellPadding="0"
                style={{
                  width: "auto",
                  borderCollapse: "separate",
                  borderSpacing: "0 0",
                }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        verticalAlign: "top",
                        whiteSpace: "nowrap",
                        padding: "4px 16px",
                      }}
                    >
                      <p dir="RTL">שם</p>
                    </td>
                    <td
                      style={{
                        verticalAlign: "top",
                        whiteSpace: "nowrap",
                        padding: "4px 16px",
                      }}
                    >
                      <p dir="RTL">תפקיד</p>
                    </td>
                    <td
                      style={{
                        verticalAlign: "top",
                        width: "200px",
                        padding: "4px 16px",
                        textAlign: "center",
                      }}
                    >
                      <p dir="RTL">חתימה</p>
                    </td>
                  </tr>
                  {bhinaMembers
                    ?.filter((member) => member.attend)
                    .map((member) => (
                      <tr key={member.id}>
                        <td
                          style={{
                            verticalAlign: "top",
                            whiteSpace: "nowrap",
                            padding: "4px 16px",
                          }}
                        >
                          {member.member_name}
                        </td>
                        <td
                          style={{
                            verticalAlign: "top",
                            whiteSpace: "nowrap",
                            padding: "4px 16px",
                          }}
                        >
                          {member.member_role}
                        </td>
                        <td
                          style={{
                            verticalAlign: "top",
                            width: "200px",
                            padding: "4px 16px",
                          }}
                        ></td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <br />
            <br />
            <br />
          </div>
        </div>
      </div>
    );
  }
};

export default Protocol;
